import React from "react"
import "./style.css"
import AlertPopup from "../../../components/AlertPopup"

const PopupUnimed = ({ isOpen, onClose }) => {
  const unimedRequirements = [
    "Confirmação do token",
    "Reconhecimento facial",
  ]

  return (
    <AlertPopup
      isOpen={isOpen}
      onClose={onClose}
      title="Atenção - UNIMED"
      mainText="Para completar o seu agendamento pela UNIMED, você precisará de um celular durante o processo."
      requirements={unimedRequirements}
      footerText="Certifique-se de que você tem um celular disponível antes de prosseguir."
      buttonText="Entendi, continuar"
      requirementsTitle="A UNIMED solicitará:"
      className="popup-unimed-overlay"
      contentClassName="popup-unimed-content"
      closeClassName="popup-unimed-close"
      bodyClassName="popup-unimed-body"
      titleClassName="popup-unimed-title"
      textClassName="popup-unimed-text"
      requirementsClassName="popup-unimed-requirements"
      subtitleClassName="popup-unimed-subtitle"
      listClassName="popup-unimed-list"
      footerClassName="popup-unimed-footer"
      buttonClassName="popup-unimed-button"
    />
  )
}

export default PopupUnimed
